import { useCallback } from "react"
import { findNextSchedulableItem } from "../utils/planQueuePresentation"

export default function useTreatmentPlanNavigation({
  clinicId,
  navigate
}) {
  const openPlan = useCallback((plan) => {
    const planPatientName = plan.patient
      ? `${plan.patient.firstName || ""} ${plan.patient.lastName || ""}`.trim()
      : ""

    localStorage.setItem(
      "odontoflow_treatment_plan_context",
      JSON.stringify({
        patientId: plan.patientId || "",
        clinicId: plan.clinicId || clinicId || "",
        patientName: planPatientName,
        planId: plan.id
      })
    )

    const params = new URLSearchParams({
      patientId: plan.patientId || "",
      clinicId: plan.clinicId || clinicId || ""
    })

    if (planPatientName) {
      params.set("patientName", planPatientName)
    }

    navigate(`/treatment-plans/${plan.id}?${params.toString()}`)
  }, [clinicId, navigate])

  const openPatientById = useCallback((patientId) => {
    if (!patientId || !clinicId) return
    navigate(`/patients/${patientId}?clinicId=${clinicId}&tab=PLANS`)
  }, [clinicId, navigate])

  const openFinanceById = useCallback((patientId, focus = "RECEIVABLES") => {
    if (!patientId || !clinicId) return

    const params = new URLSearchParams({
      clinicId: String(clinicId),
      tab: "FINANCE",
      focus: String(focus).toUpperCase()
    })

    navigate(`/patients/${patientId}?${params.toString()}`)
  }, [clinicId, navigate])

  const scheduleFromPlan = useCallback((plan) => {
    const nextItem = findNextSchedulableItem(plan)

    if (!nextItem) {
      alert("Este plan no tiene un ítem pendiente para agendar.")
      return
    }

    localStorage.setItem(
      "odontoflow_new_appointment_context",
      JSON.stringify({
        patientId: plan.patientId,
        clinicId: plan.clinicId || clinicId,
        treatmentId: nextItem.treatmentId || "",
        treatmentPlanItemId: nextItem.id || "",
        suggestedDoctorId: nextItem.suggestedDoctorId || "",
        assignedDoctorId: nextItem.assignedDoctorId || "",
        treatmentPlanId: plan.id || "",
        source: "treatment_plans_page"
      })
    )

    navigate("/agenda")
  }, [clinicId, navigate])

  return {
    openPlan,
    openPatientById,
    openFinanceById,
    scheduleFromPlan
  }
}